import { Reducer } from 'redux'
import * as types from '../constantes/user'

export const CreateUserReducer: Reducer = (state = {}, action) => {
  switch (action.type) {
    case types.CREATE_REGISTER_REQUEST:
      return {
        loading: true
      }

    case types.CREATE_REGISTER_SUCCESS:
      return {
        loading: false,
        success: action.payload
      }

    case types.CREATE_REGISTER_ERROR:
      return {
        loading: false,
        error: action.payload
      }

    case types.CREATE_REGISTER_RESET:
      return {}

    default:
      return state
  }
}

export const ValidateRegisterReducer: Reducer = (state = {}, action) => {
  switch (action.type) {
    case types.VALIDATE_REGISTER_REQUEST:
      return {
        loading: true
      }

    case types.VALIDATE_REGISTER_SUCCESS:
      return {
        loading: false,
        success: action.payload
      }

    case types.VALIDATE_REGISTER_ERROR:
      return {
        loading: false,
        error: action.payload
      }

    case types.VALIDATE_REGISTER_RESET:
      return {}

    default:
      return state
  }
}

export const ListRegisterReducer: Reducer = (state = {}, action) => {
  switch (action.type) {
    case types.LIST_REGISTER_REQUEST:
      return {
        loading: true
      }

    case types.LIST_REGISTER_SUCCESS:
      return {
        loading: false,
        listRegisters: action.payload
      }

    case types.LIST_REGISTER_ERROR:
      return {
        loading: false,
        error: action.payload
      }

    case types.LIST_REGISTER_RESET:
      return {}

    default:
      return state
  }
}

export const GenerateExcelReducer: Reducer = (state = {}, action) => {
  switch (action.type) {
    case types.GENERATE_EXCEL_REQUEST:
      return {
        loading: true
      }

    case types.GENERATE_EXCEL_SUCCESS:
      return {
        loading: false,
        success: action.payload
      }

    case types.GENERATE_EXCEL_ERROR:
      return {
        loading: false,
        error: action.payload
      }

    case types.GENERATE_EXCEL_RESET:
      return {}

    default:
      return state
  }
}

export const GetRegisterByCpfReducer: Reducer = (state = {}, action) => {
  switch (action.type) {
    case types.GET_REGISTER_BY_CPF_REQUEST:
      return {
        loading: true
      }

    case types.GET_REGISTER_BY_CPF_SUCCESS:
      return {
        loading: false,
        registerByCpf: action.payload
      }

    case types.GET_REGISTER_BY_CPF_ERROR:
      return {
        loading: false,
        error: action.payload
      }

    case types.GET_REGISTER_BY_CPF_RESET:
      return {}

    default:
      return state
  }
}

export const VerifyRegisterReducer: Reducer = (state = {}, action) => {
  switch (action.type) {
    case types.VERIFY_REGISTER_REQUEST:
      return {
        loading: true
      }

    case types.VERIFY_REGISTER_SUCCESS:
      return {
        loading: false,
        status: action.payload
      }

    case types.VERIFY_REGISTER_ERROR:
      return {
        loading: false,
        error: action.payload
      }

    case types.VERIFY_REGISTER_RESET:
      return {}

    default:
      return state
  }
}

export const ReSendSMSReducer: Reducer = (state = {}, action) => {
  switch (action.type) {
    case types.RESEND_SMS_REQUEST:
      return {
        loading: true
      }

    case types.RESEND_SMS_SUCCESS:
      return {
        loading: false,
        success: action.payload
      }

    case types.RESEND_SMS_ERROR:
      return {
        loading: false,
        error: action.payload
      }

    case types.RESEND_SMS_RESET:
      return {}

    default:
      return state
  }
}

export const UpdatePhoneReducer: Reducer = (state = {}, action) => {
  switch (action.type) {
    case types.UPDATE_PHONE_REQUEST:
      return {
        loading: true
      }

    case types.UPDATE_PHONE_SUCCESS:
      return {
        loading: false,
        success: action.payload
      }

    case types.UPDATE_PHONE_ERROR:
      return {
        loading: false,
        error: action.payload
      }

    case types.UPDATE_PHONE_RESET:
      return {}

    default:
      return state
  }
}
